import React, { useEffect, useState } from "react";
import { useApiLwaCallback } from "../hooks/api/useApiLwaCallback";
import { useNavigate } from "react-router-dom";

type CallbackStatus = "processing" | "success" | "error";

const AmazonCallback: React.FC = () => {
  const { callLwaCallback } = useApiLwaCallback();
  const navigate = useNavigate();
  const [count, setCount] = useState(5);
  const [status, setStatus] = useState<CallbackStatus>("processing");

  const getEnv = () => {
    const hostname = window.location.hostname;
    return hostname === "fba.rakulogi.com" ? "prod" : "staging";
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("spapi_oauth_code");
    const state = urlParams.get("state");
    const sellerId = urlParams.get("selling_partner_id");
    const env = getEnv();

    if (!code || !state || !sellerId) {
      console.warn("code or state is missing in the URL");
      setStatus("error");
      return;
    }

    callLwaCallback(code, state, sellerId, env)
      .then((res) => {
        // 連携失敗を「認証しました。」と表示すると、トークンが未保存のまま
        // 利用者が気付けないため、結果に応じて必ず表示を分ける
        setStatus(res ? "success" : "error");
      })
      .catch((err) => {
        console.error("LWA callback error:", err);
        setStatus("error");
      });
  }, []);

  // 成功時のみカウントダウンして自動遷移する
  useEffect(() => {
    if (status !== "success") return;

    const timer = setInterval(() => {
      setCount((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate("/userInfo");
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [status, navigate]);

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-100">
      <div className="bg-white p-6 rounded shadow-md text-center">
        {status === "processing" && (
          <>
            <h1 className="text-2xl font-bold mb-4">認証処理中です...</h1>
            <p className="text-gray-700">そのままお待ちください。</p>
          </>
        )}

        {status === "success" && (
          <>
            <h1 className="text-2xl font-bold mb-4">認証しました。</h1>
            <p className="text-gray-700">あと {count} 秒で元の画面に戻ります。</p>
          </>
        )}

        {status === "error" && (
          <>
            <h1 className="text-2xl font-bold mb-4" style={{ color: "#d32f2f" }}>
              Amazon連携に失敗しました。
            </h1>
            <p className="text-gray-700">
              お手数ですが、ユーザー情報画面からもう一度Amazon連携をやり直してください。
              <br />
              繰り返し失敗する場合は管理者にお問い合わせください。
            </p>
            <button
              className="mt-4 px-4 py-2 rounded bg-blue-600 text-white"
              onClick={() => navigate("/userInfo")}
            >
              ユーザー情報に戻る
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default AmazonCallback;
